import React, { useEffect, useRef, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useStore, useIsUser } from 'hooks';
import { Button } from 'components/ui/form';
import Modal from 'components/modal';
import WagonOrder from 'components/modal/order/wagon';
import SupplyOrder from 'components/modal/order/supply';
import AuthHelper from 'helpers/auth';
import logoSi from '../../assets/images/logo_si.png';
import User from './user';
import styles from './header.module.scss';

const Header = ({ location, history }) => {
  const { pathname, search } = location;
  const { setReload, setLoading, setUser } = useStore();
  const [order, setOrder] = useState(false);
  const orderHistoryKey = useRef(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const isUser = useIsUser();

  const orderPages = [
    '/profile/applications/supply',
    '/profile/applications/wagon',
  ];

  const isSupplyPage = [orderPages[0]].includes(pathname);
  const isWagonPage = [orderPages[1]].includes(pathname);

  useEffect(() => {
    const updateOrder = (nextLocation) => {
      orderHistoryKey.current = nextLocation.state?.orderModal
        ? nextLocation.key
        : null;
      setOrder(Boolean(nextLocation.state?.orderModal));
    };

    updateOrder(history.location);
    return history.listen(updateOrder);
  }, [history]);

  const apiUrl = (process.env.API_URL || '').replace(/\/$/, '');
  const staticUrl = process.env.STATIC_URL && !process.env.STATIC_URL.startsWith('#')
    ? process.env.STATIC_URL.replace(/\/$/, '')
    : `${apiUrl}/static`;
  const helpPdfUrl = `${staticUrl}/Руководство пользователя.pdf`;

  const onOpenOrder = (e) => {
    e.preventDefault();
    history.push({
      pathname,
      search,
      state: { orderModal: true },
    });
  };

  const onCloseOrder = () => {
    const modalKey = orderHistoryKey.current;
    orderHistoryKey.current = null;
    setOrder(false);

    if (modalKey === history.location.key) {
      history.goBack();
    }

    setReload();
  };

  const onLogout = () => {
    setShowLogoutConfirm(false);
    AuthHelper.logout({ setLoading, setUser });
  };

  const onOpenLogoutConfirm = () => setShowLogoutConfirm(true);
  const onCloseLogoutConfirm = () => setShowLogoutConfirm(false);

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link className={styles.logo} to="/">
          <img src={logoSi} alt="Гранит" className={styles.logoImg} />
        </Link>
        <div className={styles.info}>
          <div className={styles.user}>
            <User />
          </div>
        </div>
        {isUser && (isSupplyPage || isWagonPage) ? (
          <a
            className={styles.addOrder}
            onClick={e => onOpenOrder(e)}
            onKeyDown={() => {}}
          >
            Добавить заказ
          </a>
        ) : null}
        <Button
          type="submit"
          className={styles.submit}
          onClick={() => history.push('/queue')}
        >
          Очередь
        </Button>
        <Button
          type="submit"
          className={styles.submit}
          onClick={() => history.push(isUser ? '/profile/applications' : '/applications')}
        >
          {isUser ? 'Мои заявки' : 'Заявки'}
        </Button>
        <Button
          isLink
          target="_blank"
          rel="noopener noreferrer"
          className={styles.submit}
          href={helpPdfUrl}
        >
          Помощь
        </Button>
        <Button
          type="submit"
          className={styles.submit}
          onClick={onOpenLogoutConfirm}
        >
          Выйти
        </Button>
      </div>
      {isUser && order ? (
        <Modal onClose={onCloseOrder}>
          {isSupplyPage && <SupplyOrder onClose={onCloseOrder} />}
          {isWagonPage && <WagonOrder onClose={onCloseOrder} />}
        </Modal>
      ) : null}
      {showLogoutConfirm ? (
        <Modal variant="dialog" onClose={onCloseLogoutConfirm}>
          <div className={styles.logoutConfirm}>
            <p className={styles.logoutConfirmText}>Вы уверены, что хотите выйти?</p>
            <div className={styles.logoutConfirmActions}>
              <Button
                type="button"
                className={styles.logoutConfirmBtn}
                color="lightgray"
                onClick={onCloseLogoutConfirm}
              >
                Отмена
              </Button>
              <Button
                type="button"
                className={styles.logoutConfirmBtn}
                onClick={onLogout}
              >
                Выйти
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}
    </header>
  );
};

export default withRouter(Header);
